import { render, staticRenderFns } from "./Mente.vue?vue&type=template&id=6ac00eae&scoped=true&"
import script from "./Mente.vue?vue&type=script&lang=js&"
export * from "./Mente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac00eae",
  null
  
)

export default component.exports